import L from '../../leaflet-plugins-loader';
import { DomSanitizer } from '@angular/platform-browser'

const defaultIconColor = '#000000';
// Additional Color for Detected Vessel
const DETECTED_AIS_VESSEL_COLOR = "#900C3F";
const DETECTED_AIS_VESSEL_FILL_COLOR = "#C70039";

const DETECTED_RADAR_TARGET_COLOR = "#044389";
const DETECTED_RADAR_TARGET_FILL_COLOR = "#64bdf4";

const DETECTED_TLL_AIS_COLOR = "#548870";
const DETECTED_TLL_AIS_FILL_COLOR = "#a6daae";

const DETECTED_OPTIC_TARGET_COLOR = "#ff6700";
const DETECTED_OPTIC_TARGET_FILL_COLOR = "#ff9248";

const DETECTED_RADAR_TARGET_MQTT_COLOR = "#832161";
const DETECTED_RADAR_TARGET_MQTT_FILL_COLOR = "#DA4167";


export const yellowDivCircle = L.divIcon({
  html: '<div style="background-color: #ffd166; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [15, 15],
  iconAnchor: [10, 10]
});

export const blueDivCircle = L.divIcon({
  html: '<div style="background-color: #118ab2; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [15, 15],
  iconAnchor: [10, 10]
})

export const foxRedDivCircle = L.divIcon({
  html: '<div style="background-color: #ef476f; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [15, 15],
  iconAnchor: [10, 10]
});

export const redDivCircle = L.divIcon({
  html: '<div style="background-color: #F44336; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [15, 15],
  iconAnchor: [10, 10]
});


export const greenDivCircle = L.divIcon({
  html: '<div style="background-color: #52b788; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [15, 15],
  iconAnchor: [10, 10]
});


export const orangeDivCircle = L.divIcon({
  html: '<div style="background-color: #ff9f1c; width: 15px; height: 15px; border-radius: 50%;"></div>',
  className: 'custom-div-icon',
  iconSize: [20, 20],
  iconAnchor: [10, 10],
  popupAnchor: [0, -10]
});

export const sailboatIcon = (hexColor?: string) => {
  if (!hexColor) {
    hexColor = '#d3d3d3'
  }
  return L.divIcon({
    className: 'sailboat-icon',
    html: `<i class="fa-solid fa-sailboat fa-xl" style="color: ${hexColor};"></i>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12]
  })
};

export const filledFlagIcon = (iconColor?: string) => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'baseFlag',
    html: `<svg xmlns="http://www.w3.org/2000/svg" height="14" width="12.25" viewBox="0 0 448 512">
           <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
           <path fill="${color}" d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z"/>
           </svg>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}

export const checkeredFlagIcon = (iconColor?: string) => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'checkeredFlag',
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
            <path fill="${color}" d="M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80 0-66L0 64 0 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9 0 65.5L64 252.6 64 318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6L128 173.2 128 98 64 114l0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"/>
            </svg>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}


export const bullsEyeIcon = (iconColor?: string) => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'bullsEye',
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
           <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
           <path fill="${color}" d="M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
           </svg>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}

export const circleIcon = (iconColor?: string) => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'circle',
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
           <path fill="${color}" d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/>
           </svg>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}

export const moundIcon = (iconColor?: string, size: string = 'fa-lg') => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'fa-moundIcon',
    html: `<i class="fa-solid fa-mound ${size}" style="color: ${color};"></i>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}


export const squareIcon = (iconColor?: string, size: string = 'fa-xl') => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'fa-squareIcon',
    html: `<i class="fa-sharp fa-solid fa-square ${size}" style="color: ${color};"></i>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10]
  })
}

export const circleDotIcon = (iconColor?: string, size: string = 'fa-2xl') => {
  const color = iconColor ?? defaultIconColor;
  return L.divIcon({
    className: 'fa-circleDotIcon',
    html: `<i class="fa-regular fa-circle-dot ${size}" style="color: ${color};"></i>`,
    iconSize: [21, 21],
    iconAnchor: [12, 10],
    popupAnchor: [0, -10]
  })
}

export const radarTargetSvg = (sanitizer: DomSanitizer) => {
  /*`
  <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" id="svg_icon_vessel_outlined">
  <path d="m5.767 19.838 6.259 -16.166a1.155 1.155 0 0 1 0.279 -0.345 0.909 0.909 0 0 1 0.391 -0.115c0.103 0 0.297 0.053 0.393 0.115a1.155 1.155 0 0 1 0.279 0.345l6.257 16.166a1.174 1.174 0 0 1 0.021 0.466 0.943 0.943 0 0 1 -0.237 0.353 0.936 0.936 0 0 1 -0.394 0.159 1.197 1.197 0 0 1 -0.451 -0.113L12.696 16.913l-5.866 3.79a1.205 1.205 0 0 1 -0.453 0.113 0.927 0.927 0 0 1 -0.393 -0.159 0.917 0.917 0 0 1 -0.237 -0.355 1.166 1.166 0 0 1 0.019 -0.465Zm12.206 -0.945L12.696 5.261l-5.277 13.632 4.886 -3.156a1.409 1.409 0 0 1 0.782 0Z"></path>
  </svg>
  `*/

  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="770 482 40 40">
      <g>
        <path
        stroke="${DETECTED_AIS_VESSEL_COLOR}" 
        stroke-opacity="1" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        fill="${DETECTED_AIS_VESSEL_FILL_COLOR}" 
        fill-opacity="2" 
        fill-rule="evenodd"
         d="M 802.6358136988465 493.5217865371688 L 787.3126808188504 513.3470633004823 L 778.9301100485853 501.6384123414051 Z M 788 504 L 788 504">
        </path>
      </g>
    </svg>
  `;

  return sanitizer.bypassSecurityTrustHtml(svgIcon);
}

export const maritimeTargetsTLLAIS = (sanitizer: DomSanitizer) => {
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="770 482 40 40">
      <g>
        <path
        stroke="${DETECTED_TLL_AIS_COLOR}" 
        stroke-opacity="1" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        fill="${DETECTED_TLL_AIS_FILL_COLOR}" 
        fill-opacity="2" 
        fill-rule="evenodd"
         d="M 802.6358136988465 493.5217865371688 L 787.3126808188504 513.3470633004823 L 778.9301100485853 501.6384123414051 Z M 788 504 L 788 504">
        </path>
      </g>
    </svg>
  `;

  return sanitizer.bypassSecurityTrustHtml(svgIcon);
}

export const maritimeTargetsTTD = (sanitizer: DomSanitizer) => {
  const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="770 482 40 40">
      <g>
        <path
        stroke="${DETECTED_RADAR_TARGET_COLOR}" 
        stroke-opacity="1" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
        fill="${DETECTED_RADAR_TARGET_FILL_COLOR}" 
        fill-opacity="2" 
        fill-rule="evenodd"
        d="M 802.6358136988465 493.5217865371688 L 787.3126808188504 513.3470633004823 L 778.9301100485853 501.6384123414051 Z M 788 504 L 788 504">
        </path>
      </g>
    </svg>
  `;

  return sanitizer.bypassSecurityTrustHtml(svgIcon);
}
